import type { Theme } from '@mui/material';

export const styles = {
  msalLogin: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  errorMsg: (theme: Theme) => ({
    margin: '1rem',

    a: {
      textDecoration: 'none',
      color: theme.colors.info[600],
      fontWeight: '600',
    },
  }),
};
